import { useAuth0 } from "@auth0/auth0-react";
import { useEffect } from "react";
import { addAccessTokenInterceptorWithRetry } from "../apiClient";

export function useAuthentication() {
    const {
        isAuthenticated,
        getAccessTokenSilently,
        loginWithRedirect,
        user: authUser
    } = useAuth0();

    useEffect(() => {
        if (isAuthenticated && authUser) {
            addAccessTokenInterceptorWithRetry(
                (options) => getAccessTokenSilently({
                    authorizationParams: {
                        audience: process.env.REACT_APP_AUTH0_AUDIENCE,
                        scope: "openid profile email"
                    },
                    cacheMode: options?.cacheMode || 'on'
                }),
                authUser.email,
                () => loginWithRedirect()
            );
        }
    }, [isAuthenticated, authUser, getAccessTokenSilently, loginWithRedirect]);

    return {
        authUser,
        isAuthenticated
    };
}